import * as React from "react";
import { useState } from "react";
import { integerExp } from "../../utils/regex";
var EKeyCodes;
(function (EKeyCodes) {
    EKeyCodes["BACKSPACE"] = "Backspace";
    EKeyCodes["LEFT_ARROW"] = "ArrowLeft";
    EKeyCodes["RIGHT_ARROW"] = "ArrowRight";
})(EKeyCodes || (EKeyCodes = {}));
const exceptThisSymbols = ["e", "E", "+", "-", "."];
function handlekeyEvent(e) {
    exceptThisSymbols.includes(e.key) && e.preventDefault();
}
const YobInputField = (props) => {
    // stores the value of each input in array
    const [InpValue, setInpValue] = useState(["", "", "", ""]);
    // when focussed, this helps to colour the border of input_field_con
    const [focusClass, setFocusClass] = useState("focus");
    function handleChange(e, i) {
        // if (integerExp.test(e.currentTarget.value)) {
        //   const valueCopy = [...InpValue];
        //   valueCopy[i] = e.currentTarget.value;
        //   setInpValue(valueCopy);
        //   props.onChange(valueCopy.join(""));
        //   const { maxLength, value, name } = e.currentTarget;
        //   const [fieldName, fieldIndex] = name.split("-");
        //   let fieldIntIndex = parseInt(fieldIndex, 10);
        //   if (value.length >= maxLength && fieldIntIndex < 3) {
        //     const nextfield = document.querySelector(
        //       `input[name=InpfieldName-${fieldIntIndex + 1}${
        //         props.inputClassName && props.inputClassName
        //       }]`
        //     );
        //     if (nextfield !== null) {
        //       (nextfield as HTMLElement)?.focus();
        //     }
        //   } else if (fieldIntIndex <= 3) {
        //     const prevfield = document.querySelector(
        //       `input[name=InpfieldName-${fieldIntIndex - 1}${
        //         props.inputClassName && props.inputClassName
        //       }]`
        //     );
        //     if (prevfield !== null) {
        //       (prevfield as HTMLElement)?.focus();
        //     }
        //   }
        // }
        if (integerExp.test(e.currentTarget.value)) {
            const valueCopy = [...InpValue];
            valueCopy[i] = e.currentTarget.value;
            setInpValue(valueCopy);
            props.onChange(valueCopy.join(""));
        }
    }
    // go to the previous input
    function goToPrevious(event) {
        var _a, _b;
        const form = event.target.form;
        const index = (_b = (_a = Array === null || Array === void 0 ? void 0 : Array.prototype) === null || _a === void 0 ? void 0 : _a.indexOf) === null || _b === void 0 ? void 0 : _b.call(form, event.target);
        const prevInp = form === null || form === void 0 ? void 0 : form.elements[index > 0 ? index - 1 : index];
        prevInp.focus();
    }
    // // go to next input
    function goToNext(event) {
        var _a, _b, _c;
        const form = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.form;
        const index = (_c = (_b = Array === null || Array === void 0 ? void 0 : Array.prototype) === null || _b === void 0 ? void 0 : _b.indexOf) === null || _c === void 0 ? void 0 : _c.call(form, event === null || event === void 0 ? void 0 : event.target);
        const nextInp = form === null || form === void 0 ? void 0 : form.elements[index < InpValue.length - 1 ? index + 1 : index];
        nextInp === null || nextInp === void 0 ? void 0 : nextInp.focus();
    }
    React.useEffect(() => {
        if (props.defaultValue === "") {
            setInpValue(["", "", "", ""]);
            let firstInputBox = document.getElementById("otp-0");
            firstInputBox === null || firstInputBox === void 0 ? void 0 : firstInputBox.focus();
        }
    }, [props.defaultValue]);
    function handleKeyUp(e) {
        if (e.key === EKeyCodes.BACKSPACE.toString() ||
            e.key === EKeyCodes.LEFT_ARROW.toString()) {
            // if backspace or left arrow is pressed
            goToPrevious(e);
        }
        else if ((Number(e.key) >= 0 && Number(e.key) <= 9) ||
            e.key === EKeyCodes.RIGHT_ARROW.toString()) {
            // if number key or right arrow is pressed
            goToNext(e);
        }
    }
    const maxLengthCheck = (event) => {
        if (event.currentTarget.value.length > event.currentTarget.maxLength) {
            event.currentTarget.value = event.currentTarget.value.slice(0, event.currentTarget.maxLength);
        }
    };
    return (React.createElement("div", { className: `yob_inp_grp ${props === null || props === void 0 ? void 0 : props.parentsId}` }, InpValue.map((_, i) => (React.createElement("input", Object.assign({ key: i, placeholder: props.placeholder, value: InpValue[i] !== "" ? InpValue[i] : "", onChange: (e) => handleChange(e, i), onFocus: () => setFocusClass(" focus"), onBlur: () => setFocusClass(" "), className: `yob_inp mg-b10 ${focusClass} ${props.childClassName ? props.childClassName : ""}`, type: props.type
            ? props.type
            : (props === null || props === void 0 ? void 0 : props.showConfirmPinInNumbers)
                ? "text"
                : "password", min: props.min ? props.min : 0, max: props.max ? props.max : 9, maxLength: 1, 
        // onKeyDown={(e) => handlekeyEvent(e)}
        onKeyUp: (e) => handleKeyUp(e), id: props.id ? props.id + i : "yob-" + i, autoFocus: (props === null || props === void 0 ? void 0 : props.focus) === false ? false : i == 0 ? true : false, disabled: props.disabled, onInput: (e) => maxLengthCheck(e) }, (props.onKeyDown ? { onKeyDown: (e) => props.onKeyDown(e) } : {})))))));
};
export default YobInputField;
